var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "user-image",
      class: {
        blank: !_vm.imgLoaded && _vm.useBlankImage,
      },
      attrs: { "data-grm-comp": "UserProfileImage" },
    },
    [
      _vm.imgUrl && _vm.imgLoaded
        ? _c("img", {
            staticClass: "user-img",
            attrs: { src: _vm.imgUrl, alt: _vm.$t("common.user") },
            on: {
              load: _vm.emitLoadedEvent,
              error: _vm.emitImageNotFoundEvent,
            },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }